import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import "./index.css";
import { bootstrapTokenFromHash } from "./lib/token-bootstrap";
import { Toaster } from "./components/v2/Toast";
import { CookieConsent } from "./components/CookieConsent";

bootstrapTokenFromHash();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1 },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Toaster>
          <App />
          <CookieConsent />
        </Toaster>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>
);
